module.exports = __webpack_public_path__ + "img/dcs-logo@2x.5e3169aa.webp";